<template >
  <div>
    <div style="float: right; width: 300px">
      <el-input
        v-model="search"
        size="mini"
        class="searchClass"
        placeholder="输入（标题）关键字"/>
    </div>
    <el-table
      :data="tableData.filter(data => !search || data.title.toLowerCase().includes(search.toLowerCase()))"
      style="width: 100%">
      <el-table-column
        label="序号"
        prop="index">
      </el-table-column>
      <el-table-column
        label="图片标题"
        prop="title">
      </el-table-column>
      <el-table-column
        label="上传人"
        prop="upUser">
      </el-table-column>
      <el-table-column
        label="排序位置"
        prop="sortNum">
      </el-table-column>
      <el-table-column
        label="更新时间"
        prop="updateDate">
      </el-table-column>
      <el-table-column
        align="center" label="操作">
        <template slot-scope="scope" >
          <i class="el-icon-edit"  @click="handleEdit()"></i>
          <i class="el-icon-delete" style="color: red; margin-left: 15px"  @click="handleDelete()"></i>
        </template>
      </el-table-column>
    </el-table>

    <div>
      <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item label="活动名称" :label-width="formLabelWidth">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="活动区域" :label-width="formLabelWidth">
            <el-select v-model="form.region" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>


</template>

<script>
export default {
  data() {
    return {
      tableData: [{
        index: '1',
        title: '风景如花',
        upUser: '张三',
        subTitle: "第一个轮播图",
        sortNum: "1",
        updateDate: "20210124"
      } ],
      search: '',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      dialogFormVisible: false,
      formLabelWidth: '120px'
    };
  },
  methods: {
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    }
  },
  props: ["itemData"]
};
</script>




// WEBPACK FOOTER //
// src/components/syzy/lbtgl.vue